import { TFile } from '@modules/files';
import { TDocument } from '@modules/documents';
import { TInlineBlock } from '@modules/inlineBlocks/types';
import bumpVersionComponent from './bumpVersionComponent.helper';

const getValidVersionIds = (item: TDocument | TFile | TInlineBlock): string[] => {
  const originalVersionId = (item as TDocument).originalVersionId;
  if (item.versions.length <= 0 && !originalVersionId) return ['0.1'];
  const versionId = item.versions.length > 0 ? item.versions[0].id : (originalVersionId as string);
  const parts = versionId.split('.').map((n) => parseInt(n, 10));
  return parts.map((_, i) => bumpVersionComponent(versionId, i));
};

export default getValidVersionIds;
